export default {
  title: 'Secret di firma webhook',
  warning: "Salva questo secret ora — non verrà più mostrato. Usalo per verificare l'header X-Webhook-Signature.",
  done: 'Fatto',
};
